import { defineComponent as _defineComponent } from 'vue'
import { computed, onMounted, ref, watch } from 'vue';
import SignUpRequest = Vertica.LouisPoulsen.Application.Account.Api.Requests.SignUpRequest;
import CountryViewModel = Vertica.LouisPoulsen.Application.Content.ViewModels.CountryViewModel;
import CountryService from '@/services/country.service';
import { useTranslations } from '@/core/translate.mixin';
import { store } from '@/store';
import accountService from '@/services/account.service';
import pageService from '@/core/page.service';
import { useValidator } from '@/core/app.service';
import { useRouter } from 'vue-router/composables';
import { useNewsletter } from '@/store/newsletter.composable';


export default /*#__PURE__*/_defineComponent({
  __name: 'CreateAccountForm',
  setup(__props) {

const primaryCountryCode = computed<string>(() => store.getters['app/primaryCountryCode']);
const form = ref<SignUpRequest>({
    countryCode: '',
    email: '',
    firstName: '',
    lastName: '',
    newsletterAccepted: false,
    password: '',
    profilingAccepted: false,
    confirmPassword: ''
});

const countries = ref();
const selectedCountry = ref<CountryViewModel>(null);
const router = useRouter();
const isSubmitting = ref<boolean>(false);
const usernameError = ref<string>('');
const message = ref<string>('');
let returnUrl = '';

onMounted(() => {
    returnUrl = router.currentRoute.query.returnUrl as string;
    CountryService.getCountries().then(data => {
        countries.value = data;
        selectedCountry.value = data.find(x => x.countryCode === primaryCountryCode.value);
    });
});

const $validator = useValidator();
const { t } = useTranslations();
const labelNamespace = 'Pages.MyAccount.Login.CreateAccountPage';

function onSubmit() {
    $validator.validateAll()
        .then((isValid) => {
            if (isValid) {
                isSubmitting.value = true;
                accountService.createAccount(form.value).then((response) => {
                    if (response.usernameInvalid) {
                        usernameError.value = t(`${labelNamespace}.UsernameInvalidMessage`);
                    } else {
                        if (response.requireOptInConfirmation) {
                            message.value = response.message;
                        } else {
                            const redirectUrl = returnUrl || response.redirectUrl;
                            pageService.hardRedirect(redirectUrl);
                        }
                    }
                    isSubmitting.value = false;
                }).catch((response) => {
                    isSubmitting.value = false;
                });
            };
        });
}

watch(() => selectedCountry.value, () => {
    form.value.countryCode = selectedCountry.value.countryCode;
});

watch(() => form.value.email, () => { usernameError.value = ''; });

const { privacyPolicyStatementHtml, newsletterFlagText, profilingFlagText } = useNewsletter();


return { __sfc: true,primaryCountryCode, form, countries, selectedCountry, router, isSubmitting, usernameError, message, returnUrl, $validator, t, labelNamespace, onSubmit, privacyPolicyStatementHtml, newsletterFlagText, profilingFlagText }
}

})